import { ProjectFragment, WorkspaceMinimalFragment } from '@sketch/gql-types'
import { userIsEditorOrAdmin } from '../../workspace/utils'

export const getShowArchiveAction = (
  workspace: Pick<
    WorkspaceMinimalFragment,
    'userCanAdminister' | 'userCanEdit' | 'status' | 'userRole' | 'features'
  >,
  project: Pick<ProjectFragment, 'projectType'> | undefined | null
): boolean => {
  const userCanEdit =
    userIsEditorOrAdmin(workspace) && project?.projectType !== 'PERSONAL_DRAFTS'
  const archiveEnabled = workspace.features.archiveEnabled
  return userCanEdit && archiveEnabled
}
